import React from 'react';
import { useSubscription } from '../hooks/useSubscription';

// Shown by the route guards when the subscription status could not be loaded and none is known,
// instead of sending the user off as if the company had no subscription.
const SubscriptionUnavailable = () => {
  const { refreshSubscriptionStatus, loading } = useSubscription();
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4" data-subscription-unavailable>
      <div className="max-w-md text-center">
        <h2 className="text-lg font-semibold text-gray-800 mb-2">We couldn&apos;t check your company&apos;s modules</h2>
        <p className="text-sm text-gray-600 mb-4">
          The connection to the server failed. Nothing has changed in your subscription — try again in a moment.
        </p>
        <button
          type="button"
          onClick={() => refreshSubscriptionStatus()}
          disabled={loading}
          className="px-4 py-2 text-sm font-semibold text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50"
        >
          Try again
        </button>
      </div>
    </div>
  );
};

export default SubscriptionUnavailable;
